<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!-- 비상대응훈련 상세 -->
          <c-card title="LBL0002663" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <!-- 삭제 -->
                <c-btn v-if="traning.sopEmergencyTrainingId !='' && !disabled && editable" label="LBLREMOVE" icon="delete_forever" @btnClicked="remove" />
                <!-- 완료 -->
                <c-btn
                  v-if="traning.sopEmergencyTrainingId !='' && !disabled && editable"
                  :url="completeUrl"
                  :isSubmit="isComplete"
                  :param="traning"
                  mappingType="PUT"
                  label="LBLCOMPLETE"
                  icon="check"
                  @beforeAction="completePlan"
                  @btnCallback="completeCallback" 
                />
                <!-- 일괄저장 -->
                <c-btn
                  v-if="!disabled && editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="traning"
                  :mappingType="saveType"
                  label="LBLSAVEALL"
                  icon="save"
                  @beforeAction="savePlan"
                  @btnCallback="saveCallback" 
                />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <!-- 훈련명 -->
                <c-text
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="LBL0002657"
                  name="trainingName"
                  v-model="traning.trainingName">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <!-- 훈련시작일시 -->
                <c-datepicker
                  required
                  :disabled="disabled"
                  :editable="editable"
                  label="LBL0002665"
                  type="datetime"
                  :minuteStep="10"
                  name="trainingStartDate"
                  v-model="traning.trainingStartDate">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <!-- 훈련종료일시 -->
                <c-datepicker
                  required
                  :disabled="disabled"
                  :editable="editable"
                  :start="traning.trainingStartDate"
                  label="LBL0002666"
                  type="datetime"
                  :minuteStep="10"
                  name="educationDate"
                  v-model="traning.trainingEndDate">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <!-- 훈련구분 -->
                <c-select
                  required
                  :editable="editable && param.sopEmergencyTrainingId ==''"
                  :disabled="disabled && param.sopEmergencyTrainingId !=''"
                  codeGroupCd="EAP_EVAL_CLASS_CD"
                  itemText="codeName"
                  itemValue="code"
                  type="edit"
                  name="eapTrainingTypeCd"
                  label="LBL0002659"
                  v-model="traning.eapTrainingTypeCd"
                ></c-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <!-- 훈련장소 -->
                <c-text
                  :editable="editable"
                  :disabled="disabled"
                  label="LBL0002660"
                  name="trainingArea"
                  v-model="traning.trainingArea">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 교관 -->
                <c-tag 
                  :editable="editable"
                  :disabled="disabled"
                  itemText="userName"
                  itemValue="check"
                  label="LBL0002662"
                  name="trainingInstructUserIds" 
                  v-model="traning.trainingInstructUserIds"
                  icon="person"
                  @removeTag="removeInstructor"
                  @addTag="addInstructor"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <!-- 훈련통제관 -->
                <c-text
                  :editable="editable"
                  :disabled="disabled"
                  label="훈련통제관"
                  name="trainingController"
                  v-model="traning.trainingController">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-plant 
                  required
                  :disabled="disabled"
                  :editable="editable" 
                  type="edit" 
                  name="plantCd" 
                  v-model="traning.plantCd"
                  @datachange="plantChange" />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 목적 -->
                <c-textarea
                  :editable="editable"
                  :disabled="disabled"
                  label="LBL0002667"
                  :rows="2"
                  name="checkPurpose"
                  v-model="traning.checkPurpose">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 훈련개요 -->
                <c-textarea
                  :editable="editable"
                  :disabled="disabled"
                  label="LBL0002668"
                  :rows="2"
                  name="summary"
                  v-model="traning.summary">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 훈련방법 -->
                <c-textarea
                  :editable="editable"
                  :disabled="disabled"
                  label="LBL0002669"
                  :rows="2"
                  name="trainingWay"
                  v-model="traning.trainingWay">
                </c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <!-- 훈련 시나리오 정보 -->
          <c-card title="LBL0002670" class="cardClassDetailForm" :collapsed="true">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <!-- 훈련시나리오명 -->
                <c-text 
                  :afterIcon="editable && !disabled ? [
                    { name: 'search', click: true, callbackName: 'searchTraningScenario', color: 'teal' },
                    { name: 'close', click: true, callbackName: 'removeTraningScenario', color: 'red' },
                  ] : null"
                  :editable="editable"
                  :disabled="true"
                  label="LBL0002609"
                  name="trainingScenarioName"
                  v-model="traning.trainingScenarioName"
                  @searchTraningScenario="searchTraningScenario"
                  @removeTraningScenario="removeTraningScenario">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-text
                  :editable="editable"
                  :disabled="true"
                  label="Rev."
                  name="revisionNum"
                  v-model="traning.revisionNum">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 비상조치계획서명 -->
                <c-text
                  :editable="editable"
                  :disabled="true"
                  label="LBL0002679"
                  name="emergencyPlanName"
                  v-model="traning.emergencyPlanName">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 훈련내용요약 -->
                <c-textarea
                  :editable="editable"
                  :disabled="true"
                  :rows="5"
                  label="LBL0002610"
                  name="trainingContentsSummary"
                  v-model="traning.trainingContentsSummary">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 훈련시나리오개요 -->
                <c-textarea
                  :editable="editable"
                  :disabled="true"
                  :rows="5"
                  label="LBL0002642"
                  name="trainingContentsOutline"
                  v-model="traning.trainingContentsOutline">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 직접참가자 유의사항 -->
                <c-textarea
                  :editable="editable"
                  :disabled="true"
                  :rows="5"
                  label="LBL0002643"
                  name="directlyNotice"
                  v-model="traning.directlyNotice">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 간접참가자 유의사항 -->
                <c-textarea
                  :editable="editable"
                  :disabled="true"
                  :rows="2"
                  label="LBL0002644"
                  name="indirectNotice"
                  v-model="traning.indirectNotice">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 준비물 -->
                <c-textarea
                  :editable="editable"
                  :disabled="true"
                  :rows="2"
                  label="LBL0002645"
                  name="materials"
                  v-model="traning.materials">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 사전준비사항 -->
                <c-textarea
                  :editable="editable"
                  :disabled="true"
                  :rows="2"
                  label="LBL0002646"
                  name="preRequisites"
                  v-model="traning.preRequisites">
                </c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <!-- 훈련참가자 목록 -->
          <c-table
            ref="tableAttend"
            title="LBL0002671"
            :columns="grid.columns"
            :data="traning.emergencyTrainingUsersModels"
            selection="multiple"
            :editable="editable && !disabled"
            :gridHeight="grid.height"
            :hideBottom="false"
            :isExcelDown="false"
            :usePaging="false"
            rowKey="attendUserId"
          >
            <template slot="table-button">
              <q-btn-group outline >
                <!-- 추가 -->
                <c-btn v-if="editable && !disabled" label="LBLADD" :showLoading="false"  icon="add" @btnClicked="addItem" />
                <!-- 삭제 -->
                <c-btn v-if="editable && !disabled && traning.emergencyTrainingUsersModels.length > 0" label="LBLREMOVE" :showLoading="false" icon="remove" @btnClicked="removeItem" />
              </q-btn-group>
            </template>
          </c-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!-- 훈련 사진 -->
          <c-card title="LBL0002672" class="cardClassDetailForm" :collapsed="true">
            <template slot="card-detail">
              <div class="col-12">
                <c-upload 
                  label="LBL0002672"
                  :attachInfo="attachInfo"
                  :editable="editable&&!disabled">
                </c-upload>
              </div>
            </template>
          </c-card>
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'traning-detail',
  props: {
    param: {
      type: Object,
      default: () => ({
        sopEmergencyTrainingId: '',
        eapTrainingTypeCd: '',
        plantCd: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'TRAINING_PICTURE',
        taskKey: '',
      },
      grid: {
        columns: [],
        data: [],
        height: '360px'
      },
      traning: {
        sopEmergencyTrainingId: '',
        plantCd: '',
        trainingName: '',
        eapTrainingTypeCd: null,
        checkPurpose: '',
        trainingStartDate: '',
        trainingStartTime: '',
        trainingEndDate: '',
        trainingEndTime: '',
        emergencyPlanName: '',
        summary: '',
        trainingWay: '',
        trainingArea: '',
        trainingInstructUserIds: [],
        trainingController: '',
        sopEmergencyPlanId: '',
        trainingScenarioNo: '',
        evaluationUserId: '',
        evaluationOpinon: '',
        trainingCompleteFlag: 'N',
        regUserId: '',
        chgUserId: '',  

        emergencyTrainingUsersModels: [],
        emergencyTrainingEvaluationModels: [],

        // 훈련시나리오 
        trainingScenarioName: '',
        preRequisites: '',
        materials: '',
        indirectNotice: '',
        directlyNotice: '',
        trainingContentsOutline: '',
        trainingContentsSummary: '',
        revisionNum: '',

      },
      editable: true,
      detailUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        param: {},
        closeCallback: null,
      },
      saveCall: {
        saveCallData: '',
      },
      saveUrl: '',
      saveType: 'POST',
      isSave: false,
      disabled: false,
      getUrl: '',
      isComplete: false,
      completeUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 400) + 'px';
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.getUrl = selectConfig.sop.eap.training.plan.get.url;
      this.saveUrl = transactionConfig.sop.eap.training.plan.insert.url;
      this.deleteUrl = transactionConfig.sop.eap.training.plan.delete.url;
      this.getItemUrl = selectConfig.sop.eap.training.plan.getItem.url;
      this.completeUrl = transactionConfig.sop.eap.training.plan.update.url;
      // list setting
      this.getDetail();
      this.setHeader();
    },
    getDetail() {
      if (this.param.sopEmergencyTrainingId) {
        this.$http.url = this.$format(this.getUrl, this.param.sopEmergencyTrainingId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.traning = _result.data;
          // 상세팝업 최초작성/최근수정 정보 노출
          this.$emit('setRegInfo', _result.data)
          if (this.traning.trainingCompleteFlag === 'Y') {
            this.disabled = true;
          }
          this.param.eapTrainingTypeCd = _result.data.eapTrainingTypeCd
          this.param.plantCd = _result.data.plantCd
          this.$set(this.attachInfo, 'taskKey', this.param.sopEmergencyTrainingId)
        },);
        this.saveCall.saveCallData = uid();
      }
    },
    plantChange() {
      /**
       * 교관 정보 reset
       */
      this.$set(this.traning, 'trainingInstructUserIds', [])
    },
    addInstructor() {
      this.popupOptions.title = 'LBL0002673'; // 사용자 검색
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUserPopup;
    },
    closeUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (!this.traning.trainingInstructUserIds) this.traning.trainingInstructUserIds = [];
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.traning.trainingInstructUserIds, { userId: item.userId }) === -1) {
            this.traning.trainingInstructUserIds.push({
              userId: item.userId,
              userName: item.userName,
            })
          }
        })
      }
    },
    removeInstructor(item) {
      this.traning.trainingInstructUserIds = this.$_.reject(this.traning.trainingInstructUserIds, item)
    },
    searchTraningScenario() {
      this.popupOptions.title = 'LBL0002674'; // 훈련 시나리오 검색
      this.popupOptions.param = {
        type: 'single'
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/eap/emergencyActionPlanDocuPop'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeTraningScenarioPopup;
    },
    /* eslint-disable no-unused-vars */ 
    closeTraningScenarioPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.traning.emergencyPlanName = data[0].emergencyPlanName
        this.traning.trainingScenarioName = data[0].trainingScenarioName
        this.traning.trainingContentsSummary = data[0].trainingContentsSummary
        this.traning.preRequisites = data[0].preRequisites
        this.traning.revisionNum = data[0].revisionNum
        this.traning.directlyNotice = data[0].directlyNotice
        this.traning.indirectNotice = data[0].indirectNotice
        this.traning.trainingContentsOutline = data[0].trainingContentsOutline
        this.traning.materials = data[0].materials
        this.traning.sopEmergencyPlanId = data[0].sopEmergencyPlanId
        this.traning.trainingScenarioNo = data[0].trainingScenarioNo
      }
    },
    removeTraningScenario() {
      this.traning.trainingScenarioName = '';
      this.traning.trainingContentsSummary = '';
      this.traning.preRequisites = '';
      this.traning.revisionNum = '';
      this.traning.directlyNotice = '';
      this.traning.indirectNotice = '';
      this.traning.trainingContentsOutline = '';
      this.traning.materials = '';
      this.traning.sopEmergencyPlanId = '';
      this.traning.trainingScenarioNo = '';
    },
    savePlan() {
      if (this.param.sopEmergencyTrainingId) {
        this.saveUrl = transactionConfig.sop.eap.training.plan.update.url;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.sop.eap.training.plan.insert.url;
        this.saveType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.traning.regUserId = this.$store.getters.user.userId
              this.traning.chgUserId = this.$store.getters.user.userId

              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.param.sopEmergencyTrainingId = _result.data
      this.$set(this.attachInfo, 'taskKey', this.param.sopEmergencyTrainingId)
      this.$set(this.attachInfo, 'isSubmit', uid())
      this.$emit('insertTraningInfo', _result.data);
      this.getDetail();
    },
    completePlan() {
      if (this.param.sopEmergencyTrainingId) {
        this.saveUrl = transactionConfig.sop.eap.training.plan.update.url;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.sop.eap.training.plan.insert.url;
        this.saveType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGCOMPLETE', // 완료하시겠습니까?,
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.traning.regUserId = this.$store.getters.user.userId
              this.traning.chgUserId = this.$store.getters.user.userId

              this.traning.trainingCompleteFlag = 'Y';

              this.isComplete = !this.isComplete
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    datachange(data) {
      // value
      if (!this.traning.plantCd) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSG0000800', // 사업장을 선택하세요.
          type: 'warning', // success / info / warning / error
        });
        return;
      }
      this.$http.url = this.getItemUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        sopEmergencyTrainingId: this.param.sopEmergencyTrainingId ? this.param.sopEmergencyTrainingId : '',
        trainingTypeCd: data.value,
        plantCd: this.traning.plantCd,
        useFlag: 'Y',
      }
      this.$http.request((_result) => {
        this.traning.emergencyTrainingEvaluationModels = _result.data;
        this.updateMode = true;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.traning.sopEmergencyTrainingId);
          this.$http.type = 'DELETE';
          this.$http.request((_result) => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');

            this.$emit('closePopup')
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    setHeader() {
      this.$comm.getComboItems('EAP_TRAINING_USER_CLASS_CD', false).then(_result => {
        this.grid.columns = [
          {
            name: 'deptName',
            field: 'deptName',
            // 부서
            label: 'LBLDEPT',
            align: 'center',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'attendUserName',
            field: 'attendUserName',
            // 이름
            label: 'LBLNAME',
            align: 'center',
            style: 'width:140px',
            type: 'user',
            userId: 'attendUserId',
            sortable: false,
          },
          {
            setHeader: true,
            name: 'eapAttendTypeCd',
            field: 'eapAttendTypeCd',
            // 구분
            label: 'LBL0002675',
            align: 'center',
            style: 'width:150px',
            sortable: false,
            type: 'select',
            comboItems: _result
          },
          {
            setHeader: true,
            name: 'completeFlag',
            field: 'completeFlag',
            // 이수여부
            label: 'LBL0002676',
            align: 'center',
            style: 'width:80px',
            sortable: false,
            type: 'check',
            true: 'Y',
            false: 'N',
          },
          {
            name: 'nonattendanceRemark',
            field: 'nonattendanceRemark',
            // 비고(불참사유)
            label: 'LBL0002677',
            align: 'left',
            sortable: false,
            type: 'text'
          },
        ]
      });
    },
    addItem() {
      this.popupOptions.title = "LBL0002678"; // 훈련참가자 검색
      this.popupOptions.param = {
        type: 'multiple',
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.width = '60%';
      this.popupOptions.isFull = false;
      this.popupOptions.closeCallback = this.closeItemPopup;
    },
    closeItemPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.traning.emergencyTrainingUsersModels, {
            attendUserId: _item.userId,
          });
          if (index === -1) {
            this.traning.emergencyTrainingUsersModels.splice(0, 0, {
              sopEmergencyTrainingId: this.traning.sopEmergencyTrainingId,
              attendUserId: _item.userId,
              attendUserName: _item.userName,
              deptName: _item.deptName,
              eapAttendTypeCd: null,
              completeFlag: 'N',
              nonattendanceRemark: '',
            })
          }
        })
      }
    },
    removeItem() {
      let selectData = this.$refs['tableAttend'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.traning.emergencyTrainingUsersModels = this.$_.reject(this.traning.emergencyTrainingUsersModels, item)
        })
      }
    },
  }
};
</script>
